/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AppRouteImport } from './routes/_app';
import { Route as KunciRouteImport } from './routes/kunci';
import { Route as MasukRouteImport } from './routes/masuk';
import { Route as AppIndexRouteImport } from './routes/_app.index';
import { Route as AppAkunRouteImport } from './routes/_app.akun';
import { Route as AppLaporanRouteImport } from './routes/_app.laporan';
import { Route as AppPetaRouteImport } from './routes/_app.peta';
import { Route as AppSinkronisasiRouteImport } from './routes/_app.sinkronisasi';
import { Route as AppKunjunganIndexRouteImport } from './routes/_app.kunjungan.index';
import { Route as AppKunjunganLoanIdRouteImport } from './routes/_app.kunjungan.$loanId';
import { Route as AppNasabahIndexRouteImport } from './routes/_app.nasabah.index';
import { Route as AppNasabahLoanIdRouteImport } from './routes/_app.nasabah.$loanId';

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const KunciRoute = KunciRouteImport.update({
  id: '/kunci',
  path: '/kunci',
  getParentRoute: () => rootRouteImport,
} as any);
const MasukRoute = MasukRouteImport.update({
  id: '/masuk',
  path: '/masuk',
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppAkunRoute = AppAkunRouteImport.update({
  id: '/akun',
  path: '/akun',
  getParentRoute: () => AppRoute,
} as any);
const AppLaporanRoute = AppLaporanRouteImport.update({
  id: '/laporan',
  path: '/laporan',
  getParentRoute: () => AppRoute,
} as any);
const AppPetaRoute = AppPetaRouteImport.update({
  id: '/peta',
  path: '/peta',
  getParentRoute: () => AppRoute,
} as any);
const AppSinkronisasiRoute = AppSinkronisasiRouteImport.update({
  id: '/sinkronisasi',
  path: '/sinkronisasi',
  getParentRoute: () => AppRoute,
} as any);
const AppKunjunganIndexRoute = AppKunjunganIndexRouteImport.update({
  id: '/kunjungan/',
  path: '/kunjungan/',
  getParentRoute: () => AppRoute,
} as any);
const AppKunjunganLoanIdRoute = AppKunjunganLoanIdRouteImport.update({
  id: '/kunjungan/$loanId',
  path: '/kunjungan/$loanId',
  getParentRoute: () => AppRoute,
} as any);
const AppNasabahIndexRoute = AppNasabahIndexRouteImport.update({
  id: '/nasabah/',
  path: '/nasabah/',
  getParentRoute: () => AppRoute,
} as any);
const AppNasabahLoanIdRoute = AppNasabahLoanIdRouteImport.update({
  id: '/nasabah/$loanId',
  path: '/nasabah/$loanId',
  getParentRoute: () => AppRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute;
  '/kunci': typeof KunciRoute;
  '/masuk': typeof MasukRoute;
  '/akun': typeof AppAkunRoute;
  '/laporan': typeof AppLaporanRoute;
  '/peta': typeof AppPetaRoute;
  '/sinkronisasi': typeof AppSinkronisasiRoute;
  '/kunjungan/$loanId': typeof AppKunjunganLoanIdRoute;
  '/nasabah/$loanId': typeof AppNasabahLoanIdRoute;
  '/kunjungan/': typeof AppKunjunganIndexRoute;
  '/nasabah/': typeof AppNasabahIndexRoute;
}
export interface FileRoutesByTo {
  '/kunci': typeof KunciRoute;
  '/masuk': typeof MasukRoute;
  '/akun': typeof AppAkunRoute;
  '/laporan': typeof AppLaporanRoute;
  '/peta': typeof AppPetaRoute;
  '/sinkronisasi': typeof AppSinkronisasiRoute;
  '/': typeof AppIndexRoute;
  '/kunjungan/$loanId': typeof AppKunjunganLoanIdRoute;
  '/nasabah/$loanId': typeof AppNasabahLoanIdRoute;
  '/kunjungan': typeof AppKunjunganIndexRoute;
  '/nasabah': typeof AppNasabahIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_app': typeof AppRouteWithChildren;
  '/kunci': typeof KunciRoute;
  '/masuk': typeof MasukRoute;
  '/_app/akun': typeof AppAkunRoute;
  '/_app/laporan': typeof AppLaporanRoute;
  '/_app/peta': typeof AppPetaRoute;
  '/_app/sinkronisasi': typeof AppSinkronisasiRoute;
  '/_app/': typeof AppIndexRoute;
  '/_app/kunjungan/$loanId': typeof AppKunjunganLoanIdRoute;
  '/_app/nasabah/$loanId': typeof AppNasabahLoanIdRoute;
  '/_app/kunjungan/': typeof AppKunjunganIndexRoute;
  '/_app/nasabah/': typeof AppNasabahIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/kunci'
    | '/masuk'
    | '/akun'
    | '/laporan'
    | '/peta'
    | '/sinkronisasi'
    | '/kunjungan/$loanId'
    | '/nasabah/$loanId'
    | '/kunjungan/'
    | '/nasabah/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/kunci'
    | '/masuk'
    | '/akun'
    | '/laporan'
    | '/peta'
    | '/sinkronisasi'
    | '/'
    | '/kunjungan/$loanId'
    | '/nasabah/$loanId'
    | '/kunjungan'
    | '/nasabah';
  id:
    | '__root__'
    | '/_app'
    | '/kunci'
    | '/masuk'
    | '/_app/akun'
    | '/_app/laporan'
    | '/_app/peta'
    | '/_app/sinkronisasi'
    | '/_app/'
    | '/_app/kunjungan/$loanId'
    | '/_app/nasabah/$loanId'
    | '/_app/kunjungan/'
    | '/_app/nasabah/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  KunciRoute: typeof KunciRoute;
  MasukRoute: typeof MasukRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/kunci': {
      id: '/kunci';
      path: '/kunci';
      fullPath: '/kunci';
      preLoaderRoute: typeof KunciRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/masuk': {
      id: '/masuk';
      path: '/masuk';
      fullPath: '/masuk';
      preLoaderRoute: typeof MasukRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/': {
      id: '/_app/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/akun': {
      id: '/_app/akun';
      path: '/akun';
      fullPath: '/akun';
      preLoaderRoute: typeof AppAkunRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/laporan': {
      id: '/_app/laporan';
      path: '/laporan';
      fullPath: '/laporan';
      preLoaderRoute: typeof AppLaporanRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/peta': {
      id: '/_app/peta';
      path: '/peta';
      fullPath: '/peta';
      preLoaderRoute: typeof AppPetaRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/sinkronisasi': {
      id: '/_app/sinkronisasi';
      path: '/sinkronisasi';
      fullPath: '/sinkronisasi';
      preLoaderRoute: typeof AppSinkronisasiRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/kunjungan/': {
      id: '/_app/kunjungan/';
      path: '/kunjungan';
      fullPath: '/kunjungan/';
      preLoaderRoute: typeof AppKunjunganIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/kunjungan/$loanId': {
      id: '/_app/kunjungan/$loanId';
      path: '/kunjungan/$loanId';
      fullPath: '/kunjungan/$loanId';
      preLoaderRoute: typeof AppKunjunganLoanIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/nasabah/': {
      id: '/_app/nasabah/';
      path: '/nasabah';
      fullPath: '/nasabah/';
      preLoaderRoute: typeof AppNasabahIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/nasabah/$loanId': {
      id: '/_app/nasabah/$loanId';
      path: '/nasabah/$loanId';
      fullPath: '/nasabah/$loanId';
      preLoaderRoute: typeof AppNasabahLoanIdRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppAkunRoute: typeof AppAkunRoute;
  AppLaporanRoute: typeof AppLaporanRoute;
  AppPetaRoute: typeof AppPetaRoute;
  AppSinkronisasiRoute: typeof AppSinkronisasiRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppKunjunganLoanIdRoute: typeof AppKunjunganLoanIdRoute;
  AppNasabahLoanIdRoute: typeof AppNasabahLoanIdRoute;
  AppKunjunganIndexRoute: typeof AppKunjunganIndexRoute;
  AppNasabahIndexRoute: typeof AppNasabahIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAkunRoute: AppAkunRoute,
  AppLaporanRoute: AppLaporanRoute,
  AppPetaRoute: AppPetaRoute,
  AppSinkronisasiRoute: AppSinkronisasiRoute,
  AppIndexRoute: AppIndexRoute,
  AppKunjunganLoanIdRoute: AppKunjunganLoanIdRoute,
  AppNasabahLoanIdRoute: AppNasabahLoanIdRoute,
  AppKunjunganIndexRoute: AppKunjunganIndexRoute,
  AppNasabahIndexRoute: AppNasabahIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  KunciRoute: KunciRoute,
  MasukRoute: MasukRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
